import React, { useEffect, useState } from "react";
import styles from "../PreviewV3.module.css";
import { getPlanList } from "../../../JobShiftEmergencyDocuments/JobShiftEmergencyPlansDocument";

const getPlanKey = (plan, index) => `${plan && (plan.id || plan.plan_id || plan.document_number || index)}`;
const getEnabledSections = (plan) => {
  const sections = Array.isArray(plan && plan.sections) ? plan.sections : [];
  const sectionById = sections.reduce((result, section) => {
    if (section && section.id) result[section.id] = section;
    return result;
  }, {});

  return (Array.isArray(plan && plan.section_order) ? plan.section_order : [])
    .map((sectionId) => sectionById[sectionId])
    .filter((section) => section && section.data && section.data.toggle === 1);
};
const getAnchor = (planKey, suffix) => `emergency-plan-${planKey}-${suffix}`;
const getSectionLabel = (section) => section.display_name || section.title || section.id;

export default function EmergencyPlansPreviewNav({ plans }) {
  const planList = getPlanList(plans, true);
  const firstTarget = planList.length ? getAnchor(getPlanKey(planList[0], 0), "details") : "";
  const [activeTarget, setActiveTarget] = useState(firstTarget);

  useEffect(() => {
    setActiveTarget(firstTarget);
  }, [firstTarget]);

  const navigate = (event, targetId) => {
    event.preventDefault();
    setActiveTarget(targetId);
    const target = document.getElementById(targetId);
    if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <aside className={styles.PreviewNav}>
      <div className={styles.PreviewNavCard}>
        <div className={styles.PreviewNavHead}><h3>Document Sections</h3></div>
        <div id="emergency-plans-prv-nav-list">
          {planList.map((plan, planIndex) => {
            const planKey = getPlanKey(plan, planIndex);
            const items = [
              { label: "Emergency Plan Details", targetId: getAnchor(planKey, "details") },
              { label: "Document Authorization", targetId: getAnchor(planKey, "authorization") },
              ...getEnabledSections(plan).map((section) => ({
                label: getSectionLabel(section),
                targetId: getAnchor(planKey, section.id)
              })),
              { label: "Emergency Plan Team Sign Off", targetId: getAnchor(planKey, "signoff") }
            ];

            return (
              <React.Fragment key={planKey}>
                {plan.document_number ? (
                  <div className={styles.PreviewNavDocumentNumber}>{plan.document_number}</div>
                ) : null}
                <div className={styles.PreviewNavList}>
                  {items.map((item, itemIndex) => (
                    <a
                      key={`${planKey}-${item.targetId}`}
                      className={`${styles.PreviewNavItem} ${activeTarget === item.targetId ? styles.PreviewNavActiveItem : ""}`}
                      data-target={item.targetId}
                      onClick={(event) => navigate(event, item.targetId)}
                    >
                      <span className={styles.PreviewNavNum}>{itemIndex + 1}</span> {item.label}
                    </a>
                  ))}
                </div>
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </aside>
  );
}
